import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";

export interface Label {
  id: string;
  name: string;
}

let cachedLabels: Label[] | null = null;
let labelsInFlight: Promise<Label[]> | null = null;

export const useLabels = (enabled: boolean = true) => {
  const [labels, setLabels] = React.useState<Label[]>(() => cachedLabels || []);
  const [fetching, setFetching] = React.useState(enabled ? !cachedLabels : false);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    if (!enabled) return;
    if (cachedLabels) {
      setLabels(cachedLabels);
      setFetching(false);
      return;
    }
    (async () => {
      const data = await getLabels();
      if (data) setLabels(data);
    })();
  }, [enabled]);

  const getLabels = async (): Promise<Label[] | null> => {
    if (cachedLabels) return cachedLabels;
    if (labelsInFlight) return labelsInFlight;
    try {
      setFetching(true);
      labelsInFlight = axios
        .get(`${API_BASE_URL}${API_URLS.Labels}`, {
          headers: { Accept: 'application/json', Authorization: `Bearer ${token}` }
        })
        .then((r) => (r.data?.data || []) as Label[]);
      const data = await labelsInFlight;
      cachedLabels = data;
      return data;
    } catch (e) {
      console.error(e);
      return null;
    } finally {
      labelsInFlight = null;
      setFetching(false);
    }
  };

  return { labels, fetching };
};
